module.exports = __webpack_public_path__ + "static/juvenplans@2x.3fc922ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/membership/juvenplans@2x.png
// module id = 728
// module chunks = 92562407457355